const strToBool = (s) => {
  const regex = /^\s*(true|1|on)\s*$/i;
  return regex.test(s);
};

export default strToBool;
